import { Component, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { NotificationBase } from '../interfaces/notification-base.interface';
import { NotificationFactory } from '../notificationFactory';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {
  @Input('notification') notification: NotificationBase;
  componentRef: any;

  @ViewChild('notificationContainer', { static: true, read: ViewContainerRef })
  entry: ViewContainerRef;

  constructor(private notificationFactory: NotificationFactory) {
  }

  render() {
    this.entry.clear();
    this.componentRef = this.entry.createComponent(
      this.notificationFactory.create(this.notification)
    );
    (<NotificationBase>(this.componentRef.instance))._id = this.notification._id;
    (<NotificationBase>(this.componentRef.instance)).content = this.notification.content;
    (<NotificationBase>(this.componentRef.instance)).domain = this.notification.domain;
    (<NotificationBase>(this.componentRef.instance)).action = this.notification.action;
    (<NotificationBase>(this.componentRef.instance)).authorities = this.notification.authorities;
    (<NotificationBase>(this.componentRef.instance)).metadata = this.notification.metadata;
    (<NotificationBase>(this.componentRef.instance)).createdAt = this.notification.createdAt;
    (<NotificationBase>(this.componentRef.instance)).seen = this.notification.seen;
  }

  destroyComponent() {
    this.componentRef.destroy();
  }

  ngOnInit(): void {
    this.render();
  }

  ngOnDestroy(): void {
    this.destroyComponent();
  }
}
